export default __webpack_public_path__ + "static/media/790246074207174706.4a78032d.png";